import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Premium dark-neumorphic brand card. Every brand uses the exact same
// uniform surface, size and internal padding -- no brand-specific
// coloured backgrounds, no social/website links (those live exclusively
// on the brand's own page under "Official Brand Presence"). The entire
// card is clickable; the ENTER button is anchored to the same
// bottom-left position on every card regardless of description length.
const PortalCard = ({ venture }) => {
  const navigate = useNavigate();
  const { slug, name, category, description, logo } = venture;

  const goToVenture = () => navigate(`/ventures/${slug}`);
  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      goToVenture();
    }
  };

  return (
    <div
      role="link"
      tabIndex={0}
      onClick={goToVenture}
      onKeyDown={onKeyDown}
      className="neu-surface neu-surface-hover brand-card group block cursor-pointer focus-visible:outline-none"
      data-testid={`portal-card-${slug}`}
      aria-label={`${name} — ${category}`}
    >
      <div className="brand-card-logo-region">
        <img src={logo} alt={`${name} logo`} className="brand-card-logo" loading="lazy" />
      </div>
      <div className="brand-card-body">
        <span className="eyebrow !text-left" style={{ color: "var(--gg-logo-gold)" }}>{category}</span>
        <h3 className="text-h3 mt-3 mb-3">{name}</h3>
        <p className="text-body brand-card-desc">{description}</p>

        <span
          data-testid={`portal-enter-${slug}`}
          className="brand-card-enter"
        >
          Enter <ArrowRight size={14} />
        </span>
      </div>
    </div>
  );
};

export default PortalCard;
